// extracted by mini-css-extract-plugin
export var projectGroup = "ProjectGroup-module--projectGroup--wfiXC";
export var project = "ProjectGroup-module--project--1LIgE";
export var projectTextWrapper = "ProjectGroup-module--projectTextWrapper--2qMNb";
export var projectImageWrapper = "ProjectGroup-module--projectImageWrapper--3oRzs";
export var thumbnail = "ProjectGroup-module--thumbnail--2Y9bD";
export var linkWrapper = "ProjectGroup-module--linkWrapper--3nsJL";
export var link = "ProjectGroup-module--link--qbm4B";
export var icon = "ProjectGroup-module--icon--1xuqB";
export var projectTitle = "ProjectGroup-module--projectTitle--2oMK-";
export var descriptionText = "ProjectGroup-module--descriptionText--GEOQ-";
export var feature = "ProjectGroup-module--feature--1ZCBd";